import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { clearIndividualDeliveryChannelFormState } from '../store/slices/delivery-channels-form';
import {
  useLazyGetIndividualDeliveryChannelQuery,
  useCreateIndividualDeliveryChannelMutation,
  useUpdateIndividualDeliveryChannelMutation,
  useLazyGetIndividualDeliveryChannelsQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import DeliveryChannelForm from '../../partial/delivery-channels/form';

const IndividualDeliveryChannelForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const {
    individualClientsRisk: {
      deliveryChannels: {
        form: { item },
      },
    },
  } = useAppSelector((state) => state);

  const { channelId } = useParams();
  const dispatch = useAppDispatch();

  const [getIndividualDeliveryChannel, { isLoading, isFetching }] =
    useLazyGetIndividualDeliveryChannelQuery();
  const [createDeliveryChannel, { isLoading: requestInProgress, isSuccess }] =
    useCreateIndividualDeliveryChannelMutation();
  const [
    updateDeliveryChannel,
    { isLoading: updateInProgress, isSuccess: updateSuccess },
  ] = useUpdateIndividualDeliveryChannelMutation();

  const [getList] = useLazyGetIndividualDeliveryChannelsQuery();

  const getIndividualDeliveryChannelAction = useCallback(() => {
    getIndividualDeliveryChannel(channelId as string);
  }, [channelId]);

  useEffect(() => {
    setPanelIsOpen(true);

    if (channelId) {
      getIndividualDeliveryChannelAction();
    }

    return () => {
      dispatch(clearIndividualDeliveryChannelFormState());
    };
  }, [dispatch, channelId, getIndividualDeliveryChannelAction]);

  return (
    <DeliveryChannelForm
      clientType={RiskScoreClientTypeEnum.INDIVIDUAL}
      getList={getList}
      item={item}
      updateDeliveryChannel={updateDeliveryChannel}
      createDeliveryChannel={createDeliveryChannel}
      isSuccess={isSuccess}
      panelIsOpen={panelIsOpen}
      setPanelIsOpen={setPanelIsOpen}
      isLoading={isLoading || isFetching}
      requestInProgress={requestInProgress}
      updateInProgress={updateInProgress}
      updateSuccess={updateSuccess}
    />
  );
};

export default IndividualDeliveryChannelForm;
